import { useApp } from '../lib/AppContext';
import { forgetMode } from '../lib/mode';

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

// Devise signs out with DELETE; a real form submission lets it redirect back to the read-only view.
// In the native app there's no session: signing out revokes the app's token instead. Both forget the device's
// "last used" mode, so the next sign-in opens where that account's launch_mode says.
export function SignOutButton({ className }) {
  const { native } = useApp();
  if (native) return <button type="button" className={className} onClick={native.signOut}>Đăng xuất</button>;
  return (
    <form method="post" action="/logout" onSubmit={forgetMode}>
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" value={csrfToken() || ''} />
      <button type="submit" className={className}>Đăng xuất</button>
    </form>
  );
}
